import React from "react";
import styles from "./content.module.css";
import Button from "../button/button";

const ContentHead = (props) => {
  return (
    <div className={styles.content_container}>
      <h1 style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        {props.title}
      </h1>
      <div style={{ flexGrow: 1 }}></div>
      {props?.customElement}
      {props?.showBtn3 && (
        <Button
          name={props?.btn3Name}
          type={props?.btn3type}
          text={props?.btn3Text}
          style={{ marginRight: "10px" }}
          clickHandler={props.onClickHandler}
          isIcon={props?.isIcon ? props?.isIcon : false}
          iconType={props?.iconType}
        />
      )}
      {props?.showBtn2 && (
        <Button
          name={props?.btn2Name}
          type={props?.btn2type}
          text={props?.btn2Text}
          style={{ marginRight: "10px" }}
          clickHandler={props.onClickHandler}
          isIcon={props?.isIcon ? props?.isIcon : false}
          iconType={props?.iconType}
        />
      )}
      {props?.showStatusUpdateBtn && (
        <Button
          name={props?.statusUpdateBtnName}
          type={props?.statusUpdateBtnType}
          text={props?.statusUpdateBtnText}
          style={{ marginRight: "10px" }}
          clickHandler={props?.onClickHandler}
          isIcon={props?.isIcon ? props?.isIcon : false}
          iconType={props?.iconType}
        />
      )}
      {props?.showBtn1 && (
        <Button
          name={props?.btn1Name}
          type={props?.btn1type}
          text={props?.btn1Text}
          clickHandler={props?.onClickHandler}
          isIcon={props?.isIcon ? props?.isIcon : false}
          iconType={props?.iconType}
        />
      )}
    </div>
  );
};

export default React.memo(ContentHead);
